<template>
  <v-navigation-drawer
    class="side-menu text-center text-md-left mb-10"
    permanent
    fixed
  >
    <v-container class="py-6" style="background-color: white;">
      <v-row justify="center">
        <v-img src="@/assets/images/logo-tcs.webp" content width="75" max-width="75"/>
      </v-row>
    </v-container>

    <v-list dense nav class="px-0 pb-0 pt-2">
      <!-- Avatar -->
      <v-list-item class="side-menu__avatar mt-4 d-flex justify-center" >
        <v-list-item-avatar size="85" v-if="avatar">
          <v-img :src="avatarPath"></v-img>
        </v-list-item-avatar>
      </v-list-item>

      <!-- Items -->
      <v-list-item
        v-for="item in items"
        :key="item.title"
        class="side-menu__item px-5 mb-0 text-left"
        active-class="side-menu__item--active"
        :to="item.to"
      >
        <v-list-item-icon class="mr-2">
          <v-icon class="side-menu__item-icon">
            {{ item.icon || item.icon != ""  ? item.icon : "mdi-chevron-right-circle" }}
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="side-menu__item-text">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    
    <!-- Buttons -->
    <div class="mt-5 px-5" v-for="button in btns" :key="button.title">
      <v-btn class="side-menu__button" :to="button.href" outlined block>
        <v-icon v-if="button.icon" class="mr-2">{{ button.icon }}</v-icon>
        {{ button.title }}
      </v-btn>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { userComputed } from "@/store/helpers.js";
import { currentImg } from "@/libs/mixins";

export default {
    name: "SideMenu",
    mixins: [currentImg],
    data() {
        return {
            avatar: null,
            items: [],
            btns: [],
        };
    },
    computed: {
        ...userComputed,
    },
    created() {
        if (this.getUser.type == "organization" && this.getUser.role !== "sysadmin") {
            this.items.push({ title: "Publicaciones", icon: "mdi-publish", to: "/organization/home" });
            if (this.getUser.role == "admin") {
                this.items.push({ title: "Usuarios", icon: "mdi-account-circle", to: "/organization/users" });
            }
            this.items.push({ title: "Mi Pagina", icon: "mdi-home", to: { name: "OrganizationProfile" } });
            this.items.push({ title: "Mis Compras", icon: "mdi-credit-card-outline", to: "/organization/payments" });
            this.btns.push({
                title: "NUEVA PUBLICACIÓN",
                href: { name: "OfferPost", params: { followFlow: true } }
            });
            this.avatar = true;
        } else if (this.getUser.role === "sysadmin") {
            this.avatar = true;
            this.items = [
                { title: "Publicaciones", icon: "mdi-publish", to: "/sysadmin/home" },
                { title: "Usuarios", icon: "mdi-account-circle", to: "/sysadmin/admin/users" },
                { title: "Pagos", icon: "mdi-cash-register", to: "/sysadmin/admin/payments" },
                { title: "Orgs y Ofertas", icon: "mdi-office-building", to: "/sysadmin/admin/offers-organizations" },
                { title: "Descuentos", icon: "mdi-sale", to: "/sysadmin/admin/discount" },
            ];
            this.btns = [{ title: "MODERACIÓN", icon: "mdi-tune-vertical", href: "/sysadmin/moderation" }];
        } else {
            // this.items.push({title: "Inicio", icon: "mdi-home", to: "/"});
            this.items.push({ title: "Mis postulaciones", icon: "mdi-view-dashboard", to: "/candidate/home" });
            this.items.push({ title: "Mi Perfil", icon: "mdi-account-circle", to: { name: "CandidateProfile", params: { noStepper: true } } });
        }
    }
};
</script>
